import { CSSProperties } from "react";

export function aiBackgroundSvg(color: string = "#000000"): string {
  return `<svg
   width="40px"
   height="40px"
   viewBox="0 0 20 20"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <g
     transform="translate(-127.53631,-116.07296)">
    <path
       d="m 138.11952,124.01053 c 0,0.15054 -0.10372,0.27278 -0.25215,0.29765 l -1.45468,0.24236 c -0.20452,0.0341 -0.36512,0.19447 -0.39899,0.39899 l -0.24236,1.45468 c -0.0246,0.14843 -0.14711,0.25215 -0.29766,0.25215 -0.15054,0 -0.27278,-0.10372 -0.29765,-0.25215 l -0.24236,-1.45468 c -0.0341,-0.20452 -0.19447,-0.36512 -0.39899,-0.39899 L 133.08,124.30818 c -0.14843,-0.0246 -0.25215,-0.14711 -0.25215,-0.29765 0,-0.15055 0.10372,-0.27279 0.25215,-0.29766 l 1.45468,-0.24236 c 0.20452,-0.0341 0.36512,-0.19447 0.39899,-0.39899 l 0.24236,-1.45468 c 0.0246,-0.14843 0.14711,-0.25215 0.29765,-0.25215 0.15055,0 0.27279,0.10372 0.29766,0.25215 l 0.24236,1.45468 c 0.0341,0.20452 0.19447,0.36486 0.39899,0.39899 l 1.45468,0.24236 c 0.14843,0.0249 0.25215,0.14711 0.25215,0.29766 z"
       style="fill:${color};stroke-width:0.264583"
       id="path346" />
  </g>
</svg>`;
}

export function getAIBackgroundDataUrl(color: string = "#000000"): string {
  const aiBackgroundSvgEncoded = encodeURIComponent(aiBackgroundSvg(color))
    .replace(/\(/g, "%28")
    .replace(/\)/g, "%29")
    .replace(/'/g, "%27");

  return `url("data:image/svg+xml,${aiBackgroundSvgEncoded}")`;
}

export function getAIBackgroundStyle(color: string = "#000000"): CSSProperties {
  return {
    backgroundImage: getAIBackgroundDataUrl(color),
    backgroundRepeat: "repeat",
  };
}
